import React, {useMemo} from "react";
import {Card, makeStyles} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import DataTable from "react-data-table-component";
import {DeliveryCsvBonusOverview} from "api/deliveryCsvAnalysis";

const useStyles = makeStyles(() => ({
  card: {
    overflow: "auto",
  },
  territoryWarning: {
    color: "#F90",
  },
}));

interface BonusOverviewTableProps {
  bonusOverviews: DeliveryCsvBonusOverview[];
}

export const BonusOverviewTable = (props: BonusOverviewTableProps) => {
  const { bonusOverviews } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const columns = useMemo(() => [
    {
      name: t("app_csv_scanner_operator"),
      selector: (row: DeliveryCsvBonusOverview) => row.operatorName,
      sortable: true,
      width: "180px",
    },
    {
      name: t("app_csv_scanner_carrier"),
      selector: (row: DeliveryCsvBonusOverview) => row.carrierName,
      sortable: true,
      width: "180px",
    },
    {
      name: t("app_csv_scanner_territory"),
      cell: (row: DeliveryCsvBonusOverview) => (
        <span className={row.territoryName === "Hors Zone" ? classes.territoryWarning : undefined}>
          {row.territoryName}
        </span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: t("app_csv_scanner_tour_count"),
      selector: (row: DeliveryCsvBonusOverview) => row.nbTours,
      sortable: true,
      right: true,
      width: "100px",
    },
    {
      name: t("app_csv_scanner_delivery_count"),
      selector: (row: DeliveryCsvBonusOverview) => row.deliveryCount,
      sortable: true,
      right: true,
      width: "120px",
    },
    {
      name: t("app_csv_scanner_deliverypack_count"),
      selector: (row: DeliveryCsvBonusOverview) => row.packCount,
      sortable: true,
      right: true,
      width: "100px",
    },
    {
      name: t("app_csv_scanner_average_points_per_tour"),
      cell: (row: DeliveryCsvBonusOverview) => {
        const avg = row.averagePointsPerTour;
        return (avg < 2 && avg >= 1.995) ? avg?.toFixed(5) : avg?.toFixed(2);
      },
      sortable: true,
      right: true,
      width: "140px",
    },
    {
      name: t("app_csv_scanner_average_approach_distance"),
      cell: (row: DeliveryCsvBonusOverview) => `${row.averageApproachDistance?.toFixed(0)}m`,
      sortable: true,
      right: true,
      width: "140px",
    },
  ], [t, classes]);

  return (
    <Card className={classes.card}>
      <DataTable
        columns={columns}
        data={bonusOverviews}
        noHeader
        theme="colisactiv"
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 50, 100]}
        noDataComponent={<p style={{ padding: "20px" }}>{t("received_data_analysis_no_data")}</p>}
      />
    </Card>
  );
};
